import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  data: {},
  message: null,
  success: false,
  isError: false
}

export const canvasSlice = createSlice({
  name: "canvas",
  initialState,
  reducers: {
    onFetchCanvas: (state, {payload}) => {
      state.loading = true;
    },
    onFetchCanvasSuccess: (state, {payload}) => {
      state.loading = false;
      state.success = true;
      state.data = payload
    },
    onFetchCanvasError: (state, {payload}) => {
      state.loading = false;
      state.success = false;
      state.isError = true;
      state.message = payload
    }
  }
})


export const canvasSelector = (state) => state.canvas;

export const  {
  canvas,
  onFetchCanvas,
  onFetchCanvasSuccess
} = canvasSlice.actions;




export const onFetchPresignedUrl = () => {
  return (dispatch) => {
    dispatch()
  }
}



export default canvasSlice.reducer;